import DropDown from "./components/Dropdown.vue";
import SummaInput from "./components/SummaInput.vue";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    Vue.component("summa-input", SummaInput);
  }
};

export default GlobalComponents;
